import { SVButton, SVLoader } from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import WireRecipientDetailsBankInfo from '@/components/wireRecipients/details/WireRecipientDetailsBankInfo';
import WireRecipientDetailsInfo from '@/components/wireRecipients/details/WireRecipientDetailsInfo';
import WireRecipientDetailsSubmissionDetails from '@/components/wireRecipients/details/WireRecipientDetailsSubmissionDetails';
import WireRecipientDeleteCancelDialog from '@/components/wireRecipients/WireRecipientDeleteCancelDialog';
import { ROUTES } from '@/constants/routes';
import { useGetCustomerDetails } from '@/hooks/requests/useCustomers';
import { useGetWireRecipientRequestDetails } from '@/hooks/requests/useWireRecipients';
import { Card, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

export default function WireRequestsDetailsPage() {
  const [open, setOpen] = useState(false);
  const { customerId = '', uuid = '' } = useParams();
  const { customerDetails, isCustomerDetailsPending } =
    useGetCustomerDetails(customerId);
  const { wireRecipientRequestDetails, isWireRecipientRequestDetailsPending } =
    useGetWireRecipientRequestDetails(uuid);

  if (isWireRecipientRequestDetailsPending || isCustomerDetailsPending) {
    return (
      <DefaultLayout header="Wire Recipient Request">
        <SVLoader />
      </DefaultLayout>
    );
  }

  if (!wireRecipientRequestDetails || !customerDetails) {
    return (
      <DefaultLayout header="Wire Recipient Request">
        <Card>
          <Typography>
            Something went wrong retreiving the wire recipient request. Our team
            has been notified.
          </Typography>
        </Card>
      </DefaultLayout>
    );
  }

  const { firstName, lastName } = customerDetails;
  const { recipientNickName, status } = wireRecipientRequestDetails;

  return (
    <DefaultLayout
      header={recipientNickName}
      breadcrumb={[
        { label: 'Customers', href: ROUTES.CUSTOMERS },
        {
          label: `${firstName} ${lastName}`,
          href: `${ROUTES.CUSTOMERS}/${customerId}`,
        },
        {
          label: 'Wire Recipients',
          href: `${ROUTES.CUSTOMERS}/${customerId}${ROUTES.WIRE_RECIPIENTS}`,
        },
        { label: recipientNickName, isActive: true },
      ]}
      buttons={
        status === 'needs approval'
          ? [
              <SVButton
                onClick={() => setOpen(true)}
                key="cancel"
                variant="tertiary">
                Cancel
              </SVButton>,
            ]
          : []
      }>
      <Stack spacing={2}>
        <WireRecipientDetailsSubmissionDetails
          wireRecipientRequestDetails={wireRecipientRequestDetails}
        />
        <WireRecipientDetailsInfo
          wireRecipientInfo={wireRecipientRequestDetails}
        />
        <WireRecipientDetailsBankInfo bankInfo={wireRecipientRequestDetails} />
      </Stack>
      <WireRecipientDeleteCancelDialog
        uuid={uuid}
        name={recipientNickName}
        isDelete={false}
        open={open}
        setOpen={setOpen}
      />
    </DefaultLayout>
  );
}
